<template>
  <div class="content">
    <DataReportSelect
      selectTabsType="resultsData"
      @event-filter="fetchData"
    ></DataReportSelect>
    <span slot="resultsData">
      <div class="charts-warp">
        <div class="charts-container">
          <ContentBox title="用户行为分析">
            <el-row>
              <el-col
                :span="6"
                v-for="(item, index) in resultsList"
                :key="'r' + index"
              >
                <div>
                  <el-row>
                    <el-col :span="8">
                      <div class="box-title_content">
                        <p class="box-title_content_text">
                          {{ item.title }}
                          <el-tooltip
                            :content="item.content"
                            placement="right"
                            effect="light"
                          >
                            <i
                              class="el-icon-cc-info-circle"
                               style="font-size: 14px; padding-left: 6px;cursor: pointer;"
                            ></i>
                          </el-tooltip>
                        </p>
                        <p class="box-title_content_num">
                          {{ (item.personNum || 0).toLocaleString() }}
                        </p>
                      </div>

                    </el-col>
                    <el-col :span="6">
                      <div>
                        <ve-pie
                          height="100px"
                          width="100px"
                          :data="item.chartData"
                          :settings="settings"
                          :loading="loading"
                          :extend="extend"
                        >
                         <ChartDataEmpty v-if="item.chartData.rows.length === 0"/>
                        </ve-pie>
                      </div>
                    </el-col>
                    <el-col :span="10" style="height:100px;" >
                      <div style="height:70px;margin: 10px 0;text-align:center" v-show="index!==2">
                         <el-divider direction="vertical"></el-divider>
                      </div>
                    </el-col>
                  </el-row>
                </div>
              </el-col>
            </el-row>
            <el-row>
              <div style="margin:10px">
              </div>
              <el-col>
                  <ve-histogram :data="lineBar.chartData" :settings="lineBar.settings" :extend="lineBar.extend"  :loading="loading" :mark-area="markArea" :mark-line="markLine"  :y-axis="lineBar.yAxis">
                    <ChartDataEmpty v-if="lineBar.chartData.rows.length === 0"/>
                  </ve-histogram>
              </el-col>
            </el-row>
          </ContentBox>
          <ContentBox title="用户行为分析">
            <el-row>
              <el-col style="height:100px">
                <el-row>
                  <el-col :span="4" style="width:100px">
                    <div class="box-title_content_text">
                      品牌流失用户
                      <el-tooltip
                        placement="right"
                        effect="light"
                      >
                      <div slot="content">用户在以往投放中产生过转化行为（点击、扫码、付费等）后，在接下来的五次广告触达中，</br>未再与广告产生互动，包括未完整观看完该品牌广告，未再次点击、扫码及付费等行为的用户人数</div>
                        <i
                          class="el-icon-cc-info-circle"
                           style="font-size: 14px; padding-left: 6px;cursor: pointer;"
                        ></i>
                      </el-tooltip>
                    </div>
                    <div class="box-title_content_num">
                      {{ (lostNum).toLocaleString()}}
                      <span class="box-title_content_text">人</span>
                    </div>
                  </el-col>
                  <el-col :span="1">
                 <div style="height:45px;margin: 10px 0;text-align:center">
                         <el-divider direction="vertical"></el-divider>
                      </div>
                  </el-col>
                  <el-col :span="4" style="width:300px">
                    <div class="box-title_content_text">
                      转化用户<el-tooltip
                        placement="right"
                        effect="light"
                      >
                      <div slot="content">在本次投放中产生转化行为（点击、扫码、付费等）的用户</div>
                        <i
                          class="el-icon-cc-info-circle"
                          style="font-size: 14px; padding-left: 6px;cursor: pointer;"
                        ></i>
                      </el-tooltip>
                    </div>
                    <div class="box-title_content_num">
                      {{ (transformNum).toLocaleString()}}
                      <span class="box-title_content_text">人</span>
                    </div>
                  </el-col>
                </el-row>
              </el-col>
              <el-col >
                <!-- <ve-funnel :data="funnelCharts.data" :settings="funnelCharts.settings" :extend="funnelCharts.extend"> -->
                  <!-- <ChartDataEmpty v-if="lineBar.chartData.rows.length === 0"/> -->
                <!-- </ve-funnel> -->
                <div>
                <Echarts
                  id="fun"
                  :option="funnelChartsOptions"
                  style="height: 300px;"
                  v-if="transformFunnelList.length > 0"

                >
                </Echarts>
                <div v-else><ChartDataEmpty /></div>
                </div>
              </el-col>
            </el-row>
          </ContentBox>
        </div>
      </div>
    </span>
  </div>
</template>

<script>
import DataReportSelect from '@/components/DataReportSelect'
import 'echarts/lib/component/markArea'
import 'echarts/lib/component/markLine'
import 'echarts/lib/component/markPoint'
import Echarts from './Echarts'
import ChartDataEmpty from '@/components/ChartDataEmpty'
const colors = ['#1890FF',
  '#F0F2F5',
  '#B1FC03',
  '#35FC03',
  '#FC0335',
  '#FD783F',
  '#FEA37C',
  '#03FC4E',
  '#FC03B1',
  '#7CD7FE',
  '#3FC4FD',
  '#03FCCA',
  '#CA03FC',
  '#4E03FC',
  '#0335FC',
  '#03B1FC']
export default {
  inject: ['searchData'],
  components: {
    DataReportSelect,
    ChartDataEmpty,
    Echarts
  },
  data() {
    return {
      transformNum: 0, // 转换用户
      lostNum: 0, // 流失用户
      loading: false,
      mediaMaxTime: 0,
      settings: {
        label: {
          show: false,
          normal: {
            show: true,
            position: 'center',
            formatter: event => {
              if (event.dataIndex === 0) {
                return event.data.value + '%'
              } else {
                return ''
              }
            },
            textStyle: {
              fontSize: 12,
              color: 'rgba(0, 0, 0, 0.85)'
            }
          }
        }
      },
      extend: {
        tooltip: {
          confine: true
        },
        series: {
          radius: ['45%', '65%'],
          center: [40, 45],
          top: 0,
          width: '100%',
          height: '100%'
        },
        legend: {
          show: false
        },
        color: colors
      },
      resultsList: [
        {
          title: '完整播放',
          personNum: 0,
          content: '完整观看了整个广告视频的播放数量及占比',
          chartData: {
            columns: ['xData', 'yData'],
            rows: [
            ]
          }
        },
        {
          title: '有效覆盖',
          personNum: 0,
          content: '广告观看时长在5秒以上的播放数量及占比',
          chartData: {
            columns: ['xData', 'yData'],
            rows: [
            ]
          }
        },
        {
          title: '潜在用户',
          personNum: 0,
          content: '广告观看时长大于5秒、且小于视频总时长的播放数量及占比',
          chartData: {
            columns: ['xData', 'yData'],
            rows: [
            ]
          }
        }
      ],
      lineBar: {
        chartData: {
          columns: ['xData', 'pv', '跳出率'],
          rows: []
        },
        settings: {
          axisSite: { right: ['跳出率'] },
          showLine: ['跳出率'],
          yAxisName: ['曝光量', '跳出率']
        },
        yAxis: [
          {
            type: 'value',
            scale: true,
            name: '曝光量',
            max: 800000,
            min: 0,
            interval: 160000,
            splitLine: {
              lineStyle: { type: 'dashed' }
            }
          },
          {
            type: 'value',
            scale: true,
            name: '跳出率',
            max: 100,
            min: 0,
            interval: 20,
            splitLine: {
              lineStyle: { type: 'dashed' }
            }
          }
        ],

        extend: {
          title: {
            show: true,
            text: '观看时长（单位：秒）',
            x: 'center',
            y: 'bottom',
            textStyle: {
              color: 'rgba(0, 0, 0, 0.65)',
              fontSize: '14px'
            }
          },
          legend: {
            show: true,
            orient: 'horizontal',
            x: 'left',
            y: 'bottom',
            padding: [0, 0, 0, 50],
            data: ['pv', '跳出率']
          },
          grid: {
            top: 50,
            right: 20
          },
          tooltip: {
            confine: true
          },
          color: ['#1890FF', '#2FC25B'],
          series: {
            barWidth: 15
          }
        }
      },
      funnelChartsOptions: {
      },
      transformFunnelList: []
    }
  },
  computed: {
    markArea() {
      const obj = {
        silent: true,
        label: {
        },
        data: [
          [
            {
              xAxis: 4,
              name: '潜水用户',
              label: {
                position: ['50%', '50%']
              }
            },
            {
              xAxis: 15,
              itemStyle: {
                opacity: 0.5,
                color: {
                  type: 'linear',
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [{
                    offset: 0,
                    color: 'rgba(255, 255, 255, 1)' // 0% 处的颜色

                  }, {
                    offset: 1,
                    color: 'rgba(254, 220, 219, 1)' // 100% 处的颜色
                  }]
                }
              }
            }
          ],
          [
            {
              name: '',
              xAxis: 0
            },
            {
              xAxis: 4,
              itemStyle: {
                opacity: 0.5,
                color: {
                  type: 'linear',
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [{
                    offset: 0,
                    color: 'rgba(255, 255, 255, 1)' // 0% 处的颜色

                  }, {
                    offset: 1,
                    color: 'rgba(215, 232, 246, 1)' // 100% 处的颜色
                  }]
                }
              }
            }
          ],
          [
            {
              name: '潜在意向用户',
              xAxis: 15,
              label: {
                position: ['30%', '50%']
              }
            },
            {
              name: '',
              xAxis: this.mediaMaxTime - 1,
              itemStyle: {
                opacity: 0.5,
                color: {
                  type: 'linear',
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [{
                    offset: 0,
                    color: 'rgba(255, 255, 255, 1)' // 0% 处的颜色

                  }, {
                    offset: 1,
                    color: 'rgba(237, 227, 187, 1)' // 100% 处的颜色
                  }]
                }
              }
            }
          ],
          [
            {
              name: '',
              xAxis: this.mediaMaxTime - 1,

              itemStyle: {
                opacity: 0.5,
                color: {
                  type: 'linear',
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [{
                    offset: 0,
                    color: 'rgba(255, 255, 255, 1)' // 0% 处的颜色

                  }, {
                    offset: 1,
                    color: 'rgba(213, 209, 243, 1)' // 100% 处的颜色
                  }]
                }
              }
            },
            {
              name: '',
              xAxis: this.mediaMaxTime + 1
            }
          ]
        ]
      }
      return obj
    },
    markLine() {
      const obj = {
        silent: false,
        label: {
          position: 'insideMiddleTop'
        },
        lineStyle: {
          type: 'solid'
        },
        data: [
          [
            {
              name: '潜在用户域',
              xAxis: 4,
              y: 100,
              symbol: 'triangle',
              lineStyle: {
                color: 'rgba(225, 225, 225, 1)'
              },
              label: {
                formatter: function (params) {
                  let text = `{value| 潜在用户域}`;
                  return text;
                },
                rich: {
                  value: {
                    color: 'rgba(0, 0, 0, 0.94)'
                  }
                }
              }
            },
            {
              xAxis: this.mediaMaxTime - 1,
              y: 100
            }
          ],
          [
            {
              name: '目标用户域',
              xAxis: this.mediaMaxTime - 1,
              y: 100,
              symbol: 'none',
              lineStyle: {
                color: 'rgba(225, 225, 225, 1)',
                width: 0
              },
              label: {
                formatter: function (params) {
                  let text = `{value| 目标用户域}`;
                  return text;
                },
                rich: {
                  value: {
                    color: 'rgba(0, 0, 0, 1)'
                  }
                }
              }
            },
            {
              xAxis: this.mediaMaxTime,
              y: 100,
              symbol: 'none'
            }
          ],
          [
            {
              name: '有效覆盖用户域',
              xAxis: 4,
              y: 20,
              symbol: 'triangle',
              lineStyle: {
                color: 'rgba(225, 225, 225, 1)'
              },
              label: {
                formatter: function (params) {
                  let text = `{value| 有效覆盖用户域}`;
                  return text;
                },
                rich: {
                  value: {
                    color: 'rgba(0, 0, 0, 0.94)'
                  }
                }
              }
            },
            {
              xAxis: this.mediaMaxTime,
              y: 20
            }
          ]
        ]
      }
      return obj
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    fetchData() {
      if (this.searchData.model.orderId && this.searchData.model.mediaId) {
        const parmas = {
          orderId: this.searchData.model.orderId,
          mediaId: this.searchData.model.mediaId
        }
        // const parmas = {
        //   orderId: 10132,
        //   mediaId: 1793
        // }
        this.loading = true
        this.$service.getEffectReport(parmas).then(data => {
          this.resultsList[0].personNum = data.playCompletePv || 0
          this.resultsList[0].chartData.rows = [
            {
              xData: '',
              yData: data.playCompleteRatio || 0
            },
            {
              xData: '',
              yData: 100 - (data.playCompleteRatio || 0)
            }
          ]
          this.resultsList[1].personNum = data.effectPv || 0
          this.resultsList[1].chartData.rows = [
            {
              xData: '',
              yData: data.effectRatio || 0
            },
            {
              xData: '',
              yData: 100 - (data.effectRatio || 0)
            }
          ]
          this.resultsList[2].personNum = data.potentialPv || 0
          this.resultsList[2].chartData.rows = [
            {
              xData: '',
              yData: data.potentialRatio || 0
            },
            {
              xData: '',
              yData: 100 - (data.potentialRatio || 0)
            }
          ]
          this.lineBar.chartData.rows = data.playTimeList ? (data.playTimeList.slice(1, data.playTimeList.length) || []).map(item => {
            return {
              xData: item.xData,
              pv: item.pv,
              '跳出率': item.ratio || 0
            }
          }) : []
          this.mediaMaxTime = (data.playTimeList || []).length > 0 ? data.playTimeList.length - 2 : 0
          this.lostNum = data.lostNum || 0
          this.transformNum = data.transformNum || 0
          this.transformFunnelList = data.transformFunnelList || []
          // this.lineBar.extend.yAxis.forEach(item => {
          //   max =
          // })
          const ratioList = (this.transformFunnelList || []).filter(item => item.ratio).map(item => {
            return item.ratio
          })
          this.funnelChartsOptions = {
            title: [{
              text: '漏斗转化',
              left: '30%',
              textStyle: {
                color: 'rgba(0, 0, 0, 0.65)',
                fontSize: 16
              }
            }, {
              text: '人群画像',
              right: '20%',
              textStyle: {
                color: 'rgba(0, 0, 0, 0.65)',
                fontSize: 16
              }
            }],
            series: [{
              name: '漏斗图',
              color: ['rgba(125, 210, 99, 1)', 'rgba(192, 214, 109, 1)', 'rgba(108, 168, 242, 1)', 'rgba(54, 158, 228, 1)'],
              type: 'funnel',
              left: '20%',
              top: 50,
              bottom: 0,
              width: '25%',
              sort: 'descending',
              gap: 0,
              label: {
                show: true,
                position: 'inside',
                fontSize: 10,
                formatter: function (params) {
                  let text = '';
                  switch (params.dataIndex) {
                    case 0:
                      text = `{value1|${params.data.value || 0}}`;
                      break;
                    case 1:
                      text = `{value2|${params.data.value || 0}}`;
                      break;
                    case 2:
                      text = `{value3|${params.data.value || 0}}`;
                      break;
                    case 3:
                      text = `{value4|${params.data.value || 0}}`;
                      break;
                  }
                  return text;
                },
                rich: {
                  value1: {
                    color: '#fff',
                    fontWeight: 700
                  },
                  value2: {
                    color: '#fff',
                    fontWeight: 700
                  },
                  value3: {
                    color: '#fff',
                    fontWeight: 700
                  },
                  value4: {
                    color: '#ff',
                    fontWeight: 700
                  }
                }
              },
              labelLine: {
                length: 10,
                lineStyle: {
                  width: 0,
                  type: 'solid'
                }
              },
              itemStyle: {
                borderColor: '#fff',
                borderWidth: 0
              },
              emphasis: {
                itemStyle: {
                  color: '#999'
                }
              },
              markLine: {
                data: [
                  [{
                    x: '41.4%',
                    y: '37.5%',
                    lineStyle: {
                      color: 'rgba(0,0,0,0.45)',
                      type: 'solid'
                    },
                    symbol: 'none',
                    label: {
                      formatter: function (params) {
                        let text = '转化率 ' + `{value|${ratioList[ params.dataIndex] || 0}%}`;
                        return text;
                      },
                      rich: {
                        value: {
                          color: '#333',
                          fontWeight: 700
                        }
                      },
                      position: 'end'
                    }
                  },
                  {
                    x: '48%',
                    y: '37.5%',
                    symbol: 'none'
                  }
                  ],

                  [{
                    x: '39.8%',
                    y: '58.9%',
                    lineStyle: {
                      color: 'rgba(0,0,0,0.45)',
                      type: 'solid'
                    },
                    label: {
                      formatter: function (params) {
                        let text = '转化率 ' + `{value|${ratioList[ params.dataIndex] || 0}%}`;
                        return text;
                      },
                      rich: {
                        value: {
                          color: '#333',
                          fontWeight: 700
                        }
                      },
                      position: 'end'
                    },
                    symbol: 'none'
                  },
                  {
                    x: '47.1%',
                    y: '58.9%',
                    symbol: 'none'
                  }
                  ],

                  [{
                    x: '34.2%',
                    y: '79%',
                    lineStyle: {
                      color: 'rgba(0,0,0,0.45)',
                      type: 'solid'
                    },
                    label: {
                      formatter: function (params) {
                        let text = '转化率 ' + `{value|${ratioList[ params.dataIndex] || 0}%}`;
                        return text;
                      },
                      rich: {
                        value: {
                          color: '#333',
                          fontWeight: 700
                        }
                      },
                      position: 'end'
                    },
                    symbol: 'none'
                  },
                  {
                    x: '45%',
                    y: '79%',
                    symbol: 'none'
                  }
                  ]

                ]
              },
              data: this.transformFunnelList.map(item => {
                return {
                  value: item.transformNum,
                  name: item.tagName,
                  rate: '转化率',
                  rote: item.ratio || 0
                }
              })
            },
            {
              name: '漏斗图',
              type: 'funnel',
              left: '20%',
              top: 50,
              bottom: 0,
              width: '25%',
              gap: 0,
              label: {
                show: true,
                position: 'left'
              },
              labelLine: {
                length: 200,
                lineStyle: {
                  width: 1,
                  type: 'solid',
                  color: 'rgba(0, 0, 0, 0.25)'
                }
              },
              itemStyle: {
                borderColor: '#fff',
                borderWidth: 0,
                shadowColor: '#ddd'

              },
              data: this.transformFunnelList.map(item => {
                return {
                  value: item.transformNum,
                  name: item.tagName,
                  rate: '转化率',
                  rote: item.ratio || 0
                }
              })
            },
            {
              name: '漏斗图',
              type: 'funnel',
              left: '20%',
              top: 50,
              bottom: 0,
              width: '25%',
              minSize: '30%',
              legendHoverLink: false,
              gap: 0,
              label: {
                show: true,
                position: 'right',
                formatter: function (params) {
                  let text = '';
                  switch (params.dataIndex) {
                    case 0:
                      text = `${params.data.personas}`;
                      break;
                    case 1:
                      text = `${params.data.personas}`;
                      break;
                    case 2:
                      text = `${params.data.personas}`;
                      break;
                    case 3:
                      text = `${params.data.personas}`;
                      break;
                  }
                  return text;
                }
              },
              labelLine: {
                length: 400,
                lineStyle: {
                  width: 1,
                  type: 'solid',
                  color: 'rgba(0, 0, 0, 0.25)'
                }
              },
              itemStyle: {
                borderColor: '#fff',
                borderWidth: 0,
                shadowColor: '#ddd'
              },
              data: this.transformFunnelList.map(item => {
                return {
                  value: item.transformNum,
                  name: item.tagName,
                  personas: item.personas,
                  rate: '转化率',
                  rote: item.ratio || 0
                }
              })
            }
            ]
          }
          setTimeout(() => {
            this.loading = false
          }, 300);
        })
      }
    }
  }

}
</script>

<style lang="stylus" scoped>
>>>.el-divider--horizontal {
  width: 70%;
  margin: 0;
}

.charts-warp {
  display: flex;
  flex: 1;
}

.charts-container {
  width: 100%;
  height: 100%;
  margin: 0 16px;
}

p {
  margin: 0px;
}

.box-title {
  font-size: 16px;
  color: rgba(0, 0, 0, 0.65);
}

.box-title_content {
  padding: 16px 0 10px 0;
}

.box-title_content_text {
  font-size: 12px;
  color: rgba(0, 0, 0, 0.427);
  padding-bottom: 10px;
}

.box-title_content_num {
  height: 19px;
  font-size: 18px;
  color: rgba(0, 0, 0, 0.85);
  line-height: 19px;
}

.box-title_content_person {
  font-size: 14px;
  color: #333;
  padding-top: 10px;
}

>>>.el-divider--vertical {
  height: 100%;
}
</style>
